import { z } from 'zod';
// ===== Sequences =====
export const createSequenceSchema = z.object({
    name: z.string().min(1).max(100).transform(s => s.trim()),
    trigger_type: z.enum(['lead.created', 'lead.tagged', 'manual']).default('lead.created'),
    program_filter: z.string().max(100).optional(),
});
export const updateSequenceSchema = z.object({
    name: z.string().min(1).max(100).transform(s => s.trim()).optional(),
    active: z.boolean().optional(),
    program_filter: z.string().max(100).nullable().optional(),
});
// ===== Steps =====
export const createStepSchema = z.object({
    step_number: z.number().int().min(1),
    delay_days: z.number().int().min(0).default(0),
    delay_hours: z.number().int().min(0).max(23).default(0),
    channel: z.enum(['email', 'sms']).default('email'),
    template_id: z.string().uuid().nullable().optional(),
    subject_line: z.string().max(200).nullable().optional(),
});
export const updateStepSchema = z.object({
    step_number: z.number().int().min(1).optional(),
    delay_days: z.number().int().min(0).optional(),
    delay_hours: z.number().int().min(0).max(23).optional(),
    channel: z.enum(['email', 'sms']).optional(),
    template_id: z.string().uuid().nullable().optional(),
    subject_line: z.string().max(200).nullable().optional(),
    active: z.boolean().optional(),
});
// ===== Templates =====
export const createTemplateSchema = z.object({
    name: z.string().min(1).max(100).transform(s => s.trim()),
    subject: z.string().min(1).max(200).transform(s => s.replace(/[\r\n\0]/g, '').trim()),
    body_html: z.string().min(1).max(512_000),
    category: z.enum(['nurture', 'welcome', 'follow-up', 'promo']).default('nurture'),
});
export const updateTemplateSchema = z.object({
    name: z.string().min(1).max(100).transform(s => s.trim()).optional(),
    subject: z.string().min(1).max(200).transform(s => s.replace(/[\r\n\0]/g, '').trim()).optional(),
    body_html: z.string().min(1).max(512_000).optional(),
    category: z.enum(['nurture', 'welcome', 'follow-up', 'promo']).optional(),
});
// ===== Executions =====
export const enrollExecutionSchema = z.object({
    lead_id: z.string().uuid(),
    sequence_id: z.string().uuid(),
});
export const updateExecutionSchema = z.object({
    status: z.enum(['active', 'paused', 'cancelled']),
});
// ===== Query params =====
export const executionQuerySchema = z.object({
    status: z.enum(['active', 'completed', 'paused', 'cancelled', 'opted_out']).optional(),
    sequence_id: z.string().uuid().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    cursor: z.string().optional(),
});
//# sourceMappingURL=drip.js.map